export default __webpack_public_path__ + "static/media/purpleTheme-girl.56852c94.svg";